import { getUniqueColor } from "utils/helpers";
import { parseConditionHelper } from "utils/parseConditionHelper";
import {
  colorSchemeType,
  conditionsType,
} from "utils/types";

export class ColorConditionService {
  static getColorsForConditions({
    columnDataType,
    uniqueColorsData,
    conditions,
    currentValue,
  }) {
    const colors = [];

    if (
      columnDataType !== "" &&
      conditions?.length <= 0 &&
      currentValue === ""
    ) {
      return colors;
    }

    conditions?.forEach((condition) => {
      let isConditionCorrect = false;

      let { type, inputsDataArray, color } = condition;
      if (type === conditionsType.uniqueValue && !!currentValue) {
        const uniqColor = getUniqueColor(uniqueColorsData, currentValue);
        colors.push(uniqColor);
        return
      }
  
      isConditionCorrect = parseConditionHelper({ type, currentValue, dataArray: inputsDataArray, columnType: columnDataType  });

      if (isConditionCorrect) {
        colors.push(color);
      }
    });

    return colors;
  }

  static hexToRgb(hex) {
    const bigint = parseInt(hex.replace("#", ""), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return { r: r, g: g, b: b };
  }

  static getGradientColor({ gradientColors, itemsCount, currentIndex }) {
    const minColorRgb = this.hexToRgb(gradientColors.firstValue);
    const maxColorRgb = this.hexToRgb(gradientColors.secondValue);
    const gradientRange = itemsCount ? itemsCount : 1;

    const gradientStep = {
      r: (minColorRgb.r - maxColorRgb.r) / gradientRange,
      g: (minColorRgb.g - maxColorRgb.g) / gradientRange,
      b: (minColorRgb.b - maxColorRgb.b) / gradientRange,
    };

    const currentColor = {
      r: Math.round(maxColorRgb.r + gradientStep.r * currentIndex),
      g: Math.round(maxColorRgb.g + gradientStep.g * currentIndex),
      b: Math.round(maxColorRgb.b + gradientStep.b * currentIndex),
    };

    return `rgb(${currentColor.r},${currentColor.g},${currentColor.b})`;
  }

  static getGradientColorFromArray({
    gradientColors,
    tableData,
    colorColumnKey,
    currentValue,
  }) {
    const uniqueArray = tableData?.filter((item, index, arr) => {
      const currentValue = item[colorColumnKey]


      let isNotUnique = true;
      for (let i = 0; i < index; i++) {
        if (currentValue === arr[i][colorColumnKey]) {
          isNotUnique = false;
        }
      }

      return isNotUnique;
    });

    uniqueArray?.sort((a, b) => {
      const valueA = a[colorColumnKey];
      const valueB = b[colorColumnKey];

      if (typeof valueA === "number" && typeof valueB === "number") {
        return valueB - valueA;
      }

      if (typeof valueA === "string" && typeof valueB === "string") {
        return valueA.localeCompare(valueB);
      }

      return 0;
    });

    const colorGradientPalette = {};

    uniqueArray?.forEach((item, index) => {
      const currentValue = item[colorColumnKey];

      const currentColor = this.getGradientColor({
        gradientColors,
        itemsCount: uniqueArray?.length - 1,
        currentIndex: index,
      });
      colorGradientPalette[currentValue] = currentColor;
    });

    return colorGradientPalette[currentValue] ?? "black";
  }

  static getColorByColorScheme({
    colorScheme,
    uniqueColorsData,
    tableData,
    currentValue,
  }) {
    
    const currentKey = colorScheme?.colorColumn;
    const columnDataType = colorScheme?.colorColumnType;
    const currentSchemeType = colorScheme?.currentOpenTabId;
    const conditions = colorScheme?.colorSchemeConditionsData?.conditions;
    const gradientColors = colorScheme?.colorSchemeGradientData;

    switch (currentSchemeType) {
      case colorSchemeType.gradient:
        const color = this.getGradientColorFromArray({
          gradientColors: gradientColors,
          tableData: tableData,
          colorColumnKey: currentKey,
          currentKey: currentKey,
          currentValue: currentValue,
        });
        return {
          rowItemIndex: currentKey,
          color: color,
        };
      case colorSchemeType.conditionalColor:
        const resultColors = this.getColorsForConditions({
          conditions: conditions,
          currentValue: currentValue,
          uniqueColorsData: uniqueColorsData,
          columnDataType: columnDataType,
        });

        if (resultColors?.length <= 0) {
          return null;
        }

        return {
          columnId: currentKey,
          color: resultColors[resultColors?.length - 1],
        };
      default:
        return {
          columnId: currentKey,
          color: null,
        };
    }
  }
}
